export default __webpack_public_path__ + "static/media/ks.09ed5cdd.png";